import { Message } from "@apis:message/message";
import { groupBy, map } from "lodash";

type ReferenceDocWithHighlights =
  Message["GET_ONE"]["Response"]["docs"][number] & {
    highlightSpans?: { start: number; end: number }[];
  };

export const groupReferences = (
  references: ReferenceDocWithHighlights[],
): ReferenceDocWithHighlights[] => {
  // Group by title + content + reference to ensure uniqueness
  const grouped = groupBy(references, (ref) => {
    const title = ref.title || "";
    const content = ref.content || "";
    const reference = ref.reference || "";

    return `${title}_${content}_${reference}`;
  });

  return map(grouped, (group) => {
    const { highlightSpans, ...rest } = group[0];
    return {
      ...rest,
      highlightSpans: highlightSpans || [],
    };
  });
};
